import { render } from "./externalfoldershare.vue?vue&type=template&id=f7f2a706&scoped=true"
import script from "./externalfoldershare.js?vue&type=script&lang=js"
export * from "./externalfoldershare.js?vue&type=script&lang=js"

import "./externalfoldershare.vue?vue&type=style&index=0&id=f7f2a706&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f2a706"]])

export default __exports__